import { render, staticRenderFns } from "./Ptspprov.vue?vue&type=template&id=4b11857b&scoped=true"
import script from "./Ptspprov.vue?vue&type=script&lang=js"
export * from "./Ptspprov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b11857b",
  null
  
)

export default component.exports